import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY} from "../queryKeys";
import {ReachTemplate} from "./types";

type Variables = {id: string};

export const getTemplate = async (variables: Variables): Promise<ReachTemplate> => {
  const response = await axiosReachInstance.get<ReachTemplate, AxiosResponse<ReachTemplate>>(
    `/templates/${variables.id}`
  );
  return response.data;
};

export const useGetTemplate = (
  variables: Variables,
  options?: BaseQueryOptions<ReachTemplate, Variables>
): BaseUseQueryResult<ReachTemplate> => {
  return useBaseQuery<ReachTemplate, Variables>(
    [TEMPLATES_QUERY_KEY, variables.id],
    getTemplate,
    variables,
    options
  );
};
